import { __assign, __rest } from "tslib";
import * as React from 'react';
import { __RouterContext } from 'react-router';
import { NavLink, Link } from 'react-router-dom';
var ServerAnchor = function (_a) {
    var url = _a.url, nav = _a.nav, props = __rest(_a, ["url", "nav"]);
    return React.createElement("a", __assign({ href: url }, props));
};
var RouterAnchor = function (props) {
    var isNotInRouterContext = !React.useContext(__RouterContext);
    if (isNotInRouterContext || /^(https?|mailto|tel|fax):/.test(props.url)) {
        return React.createElement(ServerAnchor, __assign({}, props));
    }
    var url = props.url, nav = props.nav, rest = __rest(props, ["url", "nav"]);
    return nav ? React.createElement(NavLink, __assign({ to: url, exact: nav === 'exact' }, rest)) : React.createElement(Link, __assign({ to: url }, rest));
};
var isSsr = !globalThis.window;
/**
 * Represents a generalized anchor element that resolves either to a plain <a> or
 * a <NavLink> or a <Link> depending if the given `url` is absolute, relative or
 * exact.
 */
export var Anchor = isSsr ? ServerAnchor : RouterAnchor;
//# sourceMappingURL=index.js.map